import { render } from "./Dashboard.vue?vue&type=template&id=6e5b145a"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Components/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e5b145a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e5b145a', __exports__)) {
    api.reload('6e5b145a', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=6e5b145a", () => {
    api.rerender('6e5b145a', render)
  })

}


export default __exports__